function TeamHeader({
	isDarkMode,
	teamData,
	editingName,
	setEditingName,
	newTeamName,
	setNewTeamName,
	updatingName,
	onUpdateTeamName,
	onLeaveTeam,
	onInviteClick,
}) {
	return (
		<div className="flex items-center justify-between">
			<div>
				<div className="flex items-center gap-2">
					<h2 className="text-2xl font-bold">
						<span
							className={isDarkMode ? 'text-gray-400' : 'text-gray-500'}
						>
							Team{' '}
						</span>
						{editingName ? (
							<span className="inline-flex items-center gap-2">
								<input
									type="text"
									value={newTeamName}
									onChange={e => setNewTeamName(e.target.value)}
									onKeyDown={e => {
										if (e.key === 'Enter') onUpdateTeamName()
										if (e.key === 'Escape') {
											setEditingName(false)
											setNewTeamName('')
										}
									}}
									className={`px-2 py-1 text-xl rounded border ${
										isDarkMode
											? 'bg-gray-700 border-gray-600 text-white'
											: 'bg-white border-gray-300 text-gray-900'
									} focus:outline-none focus:ring-2 focus:ring-blue-500`}
									autoFocus
								/>
								<button
									onClick={onUpdateTeamName}
									disabled={updatingName}
									className="p-1 text-green-500 hover:text-green-400"
								>
									<svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
									</svg>
								</button>
								<button
									onClick={() => {
										setEditingName(false)
										setNewTeamName('')
									}}
									className="p-1 text-red-500 hover:text-red-400"
								>
									<svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
									</svg>
								</button>
							</span>
						) : (
							<span className={isDarkMode ? 'text-white' : 'text-gray-900'}>
								{teamData.team.name}
							</span>
						)}
					</h2>
					{teamData.isOwner && !editingName && (
						<button
							onClick={() => {
								setNewTeamName(teamData.team.name)
								setEditingName(true)
							}}
							className={`p-1 rounded hover:bg-gray-700/50 ${
								isDarkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'
							}`}
							title="Edit team name"
						>
							<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
							</svg>
						</button>
					)}
				</div>
				<div className="flex items-center gap-2 mt-2">
					<span
						className={`text-sm ${
							isDarkMode ? 'text-gray-400' : 'text-gray-600'
						}`}
					>
						{teamData.team.memberCount} of {teamData.team.seats} seats
						used
					</span>
					{teamData.isOwner &&
						teamData.team.memberCount >= teamData.team.seats && (
							<span
								className={`text-xs px-2 py-1 rounded-md ${
									isDarkMode
										? 'bg-orange-500/20 text-orange-400'
										: 'bg-orange-100 text-orange-700'
								}`}
							>
								Team is full
							</span>
						)}
				</div>
			</div>
			{teamData.isOwner ? (
				<div className="text-right">
					<button
						onClick={onInviteClick}
						className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors"
					>
						Invite User
					</button>
				</div>
			) : (
				<button
					onClick={onLeaveTeam}
					className="px-4 py-2 bg-red-500/80 text-white text-sm font-medium rounded-md hover:bg-red-500 transition-colors"
				>
					Leave Team
				</button>
			)}
		</div>
	)
}

export default TeamHeader
